"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VcfHealthClient = void 0;
const NoReportAvailableError_1 = require("../errors/NoReportAvailableError");
// https://cardata.apps.emea.vwapps.io/documentation#tag/Vehicle-Health
class VcfHealthClient {
    constructor(vhrLanguage = 'en-GB', authService, stage) {
        this.vhrLanguage = vhrLanguage;
        this.authService = authService;
        this.stage = stage;
        this.getGdcType = (isWcar) => isWcar ? `myvw-wcar-${this.stage}` : `myvw-mbb-${this.stage}`;
        this.resourceHostId = `myvw-vcf-${stage}`;
    }
    // https://cardata.apps.emea.vwapps.io/documentation#tag/Vehicle-Health/operation/getMaintenanceStatus
    async getMaintenanceStatus(vin, isWcar) {
        const url = `vehicles/${vin}/maintenance/status?gdc=${this.getGdcType(isWcar)}`;
        const headers = { 'User-Id': '__userId__' };
        const response = await this.authService.get(this.resourceHostId, url, headers);
        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }
        return await response.json();
    }
    // https://cardata.apps.emea.vwapps.io/documentation#tag/Vehicle-Health/operation/getWarningLightReports
    async getHealthReports(vin, isWcar) {
        const url = `vehicles/${vin}/warninglights?gdc=${this.getGdcType(isWcar)}`;
        const headers = { 'User-Id': '__userId__', 'Accept-Language': this.vhrLanguage };
        const response = await this.authService.get(this.resourceHostId, url, headers);
        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }
        return await response.json();
    }
    // https://cardata.apps.emea.vwapps.io/documentation#tag/Vehicle-Health/operation/getWarningLightReportByID
    async deleteHealthReport(vin, isWcar, id) {
        const url = `vehicles/${vin}/warninglights/${id}?gdc=${this.getGdcType(isWcar)}`;
        const headers = { 'User-Id': '__userId__' };
        const response = await this.authService.delete(this.resourceHostId, url, undefined, headers);
        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }
    }
    // https://cardata.apps.emea.vwapps.io/documentation#tag/Vehicle-Health/operation/getLastWarningLightsReport
    async getLatestHealthReport(vin, isWcar) {
        const url = `vehicles/${vin}/warninglights/last?gdc=${this.getGdcType(isWcar)}`;
        const headers = { 'User-Id': '__userId__', 'Accept-Language': this.vhrLanguage };
        const response = await this.authService.get(this.resourceHostId, url, headers);
        if (response.status === 404) {
            throw new NoReportAvailableError_1.NoReportAvailableError();
        }
        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }
        return await response.json();
    }
    // https://cardata.apps.emea.vwapps.io/documentation#tag/Vehicle-Health/operation/getWarningLightsSettings
    async getHealthReportSettings(vin, isWcar) {
        const url = `vehicles/${vin}/warninglights/settings?gdc=${this.getGdcType(isWcar)}`;
        const headers = { 'User-Id': '__userId__', 'Accept-Language': this.vhrLanguage };
        const response = await this.authService.get(this.resourceHostId, url, headers);
        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }
        return await response.json();
    }
    // https://cardata.apps.emea.vwapps.io/documentation#tag/Vehicle-Health/operation/setWarningLightsSettings
    async saveHealthReportSettings(vin, isWcar, healthReportSettings) {
        const url = `vehicles/${vin}/warninglights/settings?gdc=${this.getGdcType(isWcar)}`;
        const headers = { 'User-Id': '__userId__', 'Content-Type': 'application/json' };
        const response = await this.authService.put(this.resourceHostId, url, JSON.stringify(healthReportSettings), headers);
        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }
    }
    // https://cardata.apps.emea.vwapps.io/documentation#tag/Vehicle-Health/operation/triggerWarningLightsReport
    async triggerWarningLightsUpdate(vin, isWcar) {
        const url = `vehicles/${vin}/warninglights/update?gdc=${this.getGdcType(isWcar)}`;
        const headers = { 'User-Id': '__userId__', 'Content-Type': 'application/json' };
        const response = await this.authService.post(this.resourceHostId, url, JSON.stringify({}), headers);
        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }
    }
    // https://cardata.apps.emea.vwapps.io/documentation#tag/Vehicle-Health/operation/getWarningLightReportByID
    async getHealthReportById(vin, isWcar, id) {
        const url = `vehicles/${vin}/warninglights/${id}?gdc=${this.getGdcType(isWcar)}`;
        const headers = { 'User-Id': '__userId__', 'Accept-Language': this.vhrLanguage };
        const response = await this.authService.get(this.resourceHostId, url, headers);
        if (!response.ok) {
            throw new Error(`Request failed with status code ${response.status}`);
        }
        return await response.json();
    }
}
exports.VcfHealthClient = VcfHealthClient;
//# sourceMappingURL=VcfHealthClient.js.map